import { usePlosTranslations } from "../../../../../contexts/PlosTranslationsContext";
import { visuallyHidden } from "../../../../../styles/utils.css";
import { logo } from "./logo.css";
import { LogoProps } from "./types";

const Logo = ({ abbreviation, name }: LogoProps) => {
  const { fixtures } = usePlosTranslations();
  const path = `${import.meta.env.VITE_PULSE_STATIC_BASE}/broadcasters/large`;
  const abbr = abbreviation.toLowerCase();
  return (
    <>
      <span className={visuallyHidden}>{fixtures.watchLiveOn}</span>
      <img className={logo} src={`${path}/${abbr}.png`} alt={name} />
    </>
  );
};

export default Logo;
